























































import BaseComponent from '@/core/base.component';
import { Component, Vue, Watch } from 'vue-property-decorator';
import CommonTable from '@/modules/_common/components/CommonTable.vue';
import noticeboardService from '@/services/notice-board.service';
import { Pagination } from '@/common/interfaces/pagination.type';
import { NoticeBoardDto, NoticeBoardSearchDto } from '@/dto/notice-board';
import { NOTICE_BOARD_TYPE, CONST_NOTICE_BOARD_TYPE } from '@/services/shared';
import codeManagementService from '@/services/init/code-management.service';
import { CodeManagementDto } from '@/services/init/dto';

@Component({
  name: 'NoticeBoard',
  components: { CommonTable },
})
export default class Contracts extends BaseComponent {
  private pagination = new Pagination();
  private noticeBoardList: NoticeBoardDto[] = [];
  private noticeBoradListCount = null;
  private noticeBoardSearchDto = new NoticeBoardSearchDto();
  private loading = false;
  private noticeBoardTypeSelect: CodeManagementDto[] = [];
  private headers = [
    {
      text: '문의유형',
      value: 'codeManagement.value',
      align: 'center',
    },
    {
      text: '제목',
      value: 'title',
      align: 'left',
    },
    {
      text: '생성일',
      value: 'createdAt',
      align: 'center',
    },
  ];

  toSelectedItemPage(value) {
    this.$router.push(`/notice-board/${value.no}`);
  }

  getNoticeBoardType() {
    codeManagementService.findNoticeBoardType().subscribe(res => {
      if (res) {
        this.noticeBoardTypeSelect = res.data;
      }
    });
  }

  getList() {
    this.loading = true;
    noticeboardService
      .findAll(this.noticeBoardSearchDto, this.pagination)
      .subscribe(res => {
        this.noticeBoardList = res.data.items;
        this.noticeBoradListCount = res.data.totalCount;
        this.loading = false;
      });
  }

  search() {
    this.getList();
  }

  reset() {
    this.noticeBoardSearchDto = new NoticeBoardSearchDto();
    this.getList();
  }

  created() {
    this.getList();
    this.getNoticeBoardType();
  }
  activated() {
    this.getList();
  }
}
